import React, { Component } from 'react';

import './DeferDeleteFail.scss';

import { AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL } from '../../../redux/modules/modals/modals.module';
import {
  COLLEGE_FUND_NOTE_PHONE_NUMBERS,
  TOLL_FREE_NUMBER,
} from '../../../settings/settings';
import Button from '../../Shared/Button/Button';
import Phone from '../../Shared/Phone/Phone';
import { isProductType529 } from '../../../utils/funds/funds-utility';

class DeferDeleteFail extends Component {
  componentDidMount() {
    const { dispatchPageLoad, fund, type, actionType } = this.props;
    const modalName = isProductType529(fund.productType)
      ? actionType === 'delete'
        ? 'College|Contribute|DeleteFailureModal'
        : actionType === 'skip'
        ? 'College|Contribute|SkipFailureModal'
        : 'College|Contribute|SkipCancelFailureModal'
      : actionType === 'delete'
      ? `${type}|DeleteFailureModal`
      : actionType === 'skip'
      ? `${type}|SkipFailureModal`
      : 'Buy|SkipCancelFailureModal';
    dispatchPageLoad(modalName);
  }

  render() {
    const { closeModal, fund } = this.props;
    return (
      <div>
        <div className="defer-delete-fail-title">
          We were unable to process your request.
        </div>
        <div className="defer-delete-fail-subTitle">
          Please call us at{' '}
          <Phone
            phoneNumber={
              isProductType529(fund.productType)
                ? COLLEGE_FUND_NOTE_PHONE_NUMBERS[fund.productType]
                : TOLL_FREE_NUMBER
            }
          />{' '}
          to proceed
        </div>
        <div className="defer-delete-fail-button-container">
          <Button
            className="defer-delete-fail-button"
            buttonType="primary"
            styleName="defer-delete-fail-button"
            disabled={false}
            id="delete-btn"
            onClick={() => closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL)}
          >
            Ok
          </Button>
        </div>
      </div>
    );
  }
}

export default DeferDeleteFail;
